import { Component, Input, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'gauge-chart',
  templateUrl: './gauge.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./gauge.component.scss']
})
export class GaugeChartComponent implements OnInit, OnChanges {
  @Input()
  value = 0;

  @Input()
  isDecimal = true;

  public color: string;

  public ngOnInit(): void {
    if (this.isDecimal) {
      this.value = this.value * 100;
    }

    this.changeColor();
  }

  public ngOnChanges(): void {
    this.changeColor();
  }

  private changeColor(): void {
    if (this.value >= 75) {
      this.color = '#1a61f7';
    } else if (this.value >= 50) {
      this.color = '#e4771f';
    } else {
      this.color = '#fc3868';
    }
  }
}
